import * as Store from '@apply/store';
import { connect } from 'react-redux';
import { QuestionValidateType, ShowIf } from '@apply/ui';
import {
    BudgetFile,
    ConstructionStarted,
    ContactInformation,
    GeneralContractor,
    GeneralContractorCompany,
    GeneralContractorFile,
    LandSize,
    LegalDescription,
    OnsitePropertyContact,
    PlansFile,
    PreSaleContractFile,
    PreSold,
    SpecSheetFile,
    StructureType,
    SurveyFile,
    PropertyAddress,
    ExpectedListingPrice,
    Units,
} from '../questions/index';

export interface ConstructionProps {
    onQuestionValidate?: QuestionValidateType;
    submitted: boolean;
    handleFileSelected: (
        fileType: string,
        file: File,
        updater: (guid: string, value: Store.PropertiesStore.Types.Attachment) => unknown
    ) => Promise<void>;
    disableEditFormOptionBudget: boolean;
    disableEditFormOptionSpecSheet: boolean;
    property: Store.PropertiesStore.Types.Property;
}

const Construction: React.FC<ConstructionProps> = ({
    onQuestionValidate,
    submitted,
    handleFileSelected,
    disableEditFormOptionBudget,
    disableEditFormOptionSpecSheet,
    property,
}) => {
    return (
        <>
            <StructureType
                onQuestionValidate={onQuestionValidate}
                submitted={submitted}
                required={true}
            />
            <ShowIf showIf={property.structureType === '5+ Unit'}>
                <Units
                    onQuestionValidate={onQuestionValidate}
                    submitted={submitted}
                    required={true}
                />
            </ShowIf>
            <PropertyAddress
                onQuestionValidate={onQuestionValidate}
                submitted={submitted}
                required={true}
            />
            <LegalDescription
                onQuestionValidate={onQuestionValidate}
                submitted={submitted}
            />
            <LandSize
                onQuestionValidate={onQuestionValidate}
                submitted={submitted}
            />
            <GeneralContractor
                onQuestionValidate={onQuestionValidate}
                submitted={submitted}
                required={true}
            />
            <ShowIf showIf={property.nonRental?.generalContractorWillWork}>
                <GeneralContractorCompany
                    onQuestionValidate={onQuestionValidate}
                    submitted={submitted}
                    required={true}
                />
                <GeneralContractorFile
                    onQuestionValidate={onQuestionValidate}
                    submitted={submitted}
                    handleFileSelected={handleFileSelected}
                    required={true}
                />
            </ShowIf>

            <ShowIf showIf={!property.nonRental?.generalContractorWillWork}>
                <OnsitePropertyContact
                    onQuestionValidate={onQuestionValidate}
                    submitted={submitted}
                    required={true}
                />
            </ShowIf>
            <ShowIf showIf={!property.nonRental?.generalContractorWillWork && property.nonRental?.contactIsPrimary === false}>
                <ContactInformation
                    onQuestionValidate={onQuestionValidate}
                    submitted={submitted}
                />
            </ShowIf>
            <BudgetFile
                onQuestionValidate={onQuestionValidate}
                submitted={submitted}
                handleFileSelected={handleFileSelected}
                disableEditFormOptionBudget={disableEditFormOptionBudget}
                required={true}
            />
            <PlansFile
                onQuestionValidate={onQuestionValidate}
                submitted={submitted}
                handleFileSelected={handleFileSelected}
                required={true}
            />
            <SpecSheetFile
                onQuestionValidate={onQuestionValidate}
                submitted={submitted}
                handleFileSelected={handleFileSelected}
                disableEditFormOptionSpecSheet={disableEditFormOptionSpecSheet}
                required={true}
            />
            <ShowIf showIf={property.nonRental?.specSheet?.handleMode === 'willnotprovide'}>
                <p style={{ color: 'red', marginLeft: 20 }}>
                    NOTE: Without this detail, the appraiser is likely to assume the lowest grade materials.
                </p>
            </ShowIf>
            <SurveyFile
                onQuestionValidate={onQuestionValidate}
                submitted={submitted}
                handleFileSelected={handleFileSelected}
                required={true}
            />
            <PreSold
                onQuestionValidate={onQuestionValidate}
                submitted={submitted}
                required={true}
            />
            <ShowIf showIf={property.nonRental?.preSold}>
                <PreSaleContractFile
                    onQuestionValidate={onQuestionValidate}
                    submitted={submitted}
                    handleFileSelected={handleFileSelected}
                    required={true}
                />
            </ShowIf>
            <ShowIf showIf={property.nonRental?.preSold === false}>
                <ExpectedListingPrice
                    onQuestionValidate={onQuestionValidate}
                    submitted={submitted}
                    required={true}
                />
            </ShowIf>
            <ConstructionStarted
                onQuestionValidate={onQuestionValidate}
                submitted={submitted}
                required={true}
            />
        </>
    );
};

export const mapStateToProps = (state: Store.ApplyRootStateType) => {
    return {
        property: state.properties.items.find((itm) => itm.guid === state.properties.currentPropertyId),
    };
};

export default connect(mapStateToProps)(Construction);
